<div>
  <form novalidate #itemMaintForm="ngForm">

          <kendo-grid
          #itemMaintForm
          [kendoGridBinding]="glItemsAll"
          [pageSize]="pageSize"
          [resizable]="true"
            [pageable]="{
                            buttonCount: 5,
                            info: true,
                            type: 'numeric',
                            pageSizes: [20, 40, 60],
                            previousNext: true
                            }"
            [sortable]="true"
            [sort]="sort"
            [scrollable]="true"
            (pageChange)="pageChange($event)"
            [selectable]="{
                      mode: 'single',
                      checkboxOnly: true}"
            [skip]="skip"
            (add)="addHandler($event)"
            (dataStateChange)="onStateChange($event)"
            (cancel)="cancelHandler($event)"
            (cellClick)="cellClickHandler($event)"
            (save)="saveHandler($event)"
            (remove)="removeClicked($event)"
            (edit)="editClicked($event)"
            [reorderable]="true"
            [filterable]="true"
            (excelExport)="excelExported($event)">
            <ng-template kendoGridToolbarTemplate>
              <div>GL Guide:
                <kendo-dropdownlist class="guide-list"
                [data]="glguideDescriptions"
                [(ngModel)]="selectedValue"
                  name="selectedValue"
                  (valueChange)="guideChange($event)"
                  (excelExport)="excelExported($event)"
                  style = "  margin-left: 8px;
                  height: 33px;
                  width: 200px;">
                </kendo-dropdownlist>
              </div>
              <div class="maintenance-buttons">
                <button class="maint-button" type="app-mcl-button" primary="true" [disabled]="isEditable" kendoGridAddCommand>Add New</button>
                <app-mcl-button class="maint-button" primary="true" text="Save Changes"
                  [disabled]="!glguideService.hasChanges() || !isEditable" (click)="saveChanges(itemMaintForm, $event);">Save Changes
                </app-mcl-button>
                <app-mcl-button class="maint-button" primary="true" text="Cancel Changes"
                  [disabled]="!isEditable" (click)="cancelChanges();">Cancel
                  Changes</app-mcl-button>
              </div>

              <div class="gl-print-btns" fxFlex fxLayout="row" fxLayoutAlign="end end">
                <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(grid)" type="button" icon="file-pdf"
                  primary="true" text="Export to PDF"></app-mcl-button>

                <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(grid)" icon="file-excel" primary="true"
                  text="Export to Excel"></app-mcl-button>
                <kendo-grid-column-chooser style="float:right"></kendo-grid-column-chooser>
              </div>
            </ng-template>
            <kendo-grid-column field="seq" title="Seq." [width]="150"></kendo-grid-column>
            <kendo-grid-column field="glcode" title="GL Code and Description" [width]="150">
              <ng-template
                           kendoGridEditTemplate
                           let-dataItem="dataItem">
                <kendo-dropdownlist
                           name="selectedCategory"
                           [data]="glCodes"
                           valueField="glCode"
                           valuePrimitive="true"
                           textField="codeDescription"
                           [defaultItem]="dataItem.glCode"
                          [(ngModel)]="selectedCategory"
                          (valueChange)="valueChange($event, dataItem)">
                </kendo-dropdownlist>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="itemNo" title="Item No." [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.itemNo }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="itemDesc" title="Item Description" [width]="180"></kendo-grid-column>
            <kendo-grid-command-column width="180">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button class="command-button" kendoGridRemoveCommand>Remove</button>
                <button class="command-button" *ngIf="isNew" kendoGridSaveCommand>Add</button>
                <button  *ngIf="isNew" kendoGridCancelCommand>Cancel</button>
              </ng-template>
            </kendo-grid-command-column>
            <!-- Pdf Export -->
            <kendo-grid-pdf fileName="GlMaintainItem.pdf" [author]="'McLane'" [producer]="'McLane'" paperSize="A4"
              [repeatHeaders]="false" [landscape]="true" [scale]="scale" [allPages]="true">
              <kendo-grid-column field="seq" title="Seq.">
              </kendo-grid-column>
              <kendo-grid-column field="glcode" title="GL Code and Description">
              </kendo-grid-column>
              <kendo-grid-column field="itemNo" title="Item No.">
              </kendo-grid-column>
              <kendo-grid-column field="itemDesc" title="Item Description">
              </kendo-grid-column>
              <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
              <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <div class="page-template">
                  <div class="header">
                    <div style="float: right">
                      Page {{ pageNum }} of {{ totalPages }}
                    </div>
                    <p> Online-Invoice - GL-MaintainItems</p>
                  </div>
                </div>
              </ng-template>
            </kendo-grid-pdf>

            <!-- Excel Export -->
            <kendo-grid-excel fileName="GlMaintainItem.xlsx" [fetchData]="exportAllData">
              <kendo-excelexport-column field="seq" title="Seq.">
              </kendo-excelexport-column>
              <kendo-excelexport-column field="glcode" title="GL Code and Description">
              </kendo-excelexport-column>
              <kendo-excelexport-column field="itemNo" title="Item No.">
              </kendo-excelexport-column>
              <kendo-excelexport-column field="itemDesc" title="Item Description">
              </kendo-excelexport-column>
            </kendo-grid-excel>
          </kendo-grid>
    <div kendoDialogContainer></div>
  </form>
</div>
